var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "yoyo-container mx-auto pb-[env(safe-area-inset-bottom)]" },
    [
      _c("navBar", { attrs: { title: _vm.iccid } }),
      _c(
        "div",
        { staticClass: "pb-4" },
        [
          _c("AddressForm", {
            ref: "addressForm",
            attrs: {
              addressData: _vm.addressData,
              showAddress: _vm.showAddress,
            },
            on: { "register-check": _vm.handleRegisterCheck },
          }),
          _c("PayProduct", { attrs: { products: _vm.settleProducts } }),
          _c("PaymentSummary", {
            attrs: {
              priceInfo: _vm.settlementData.price,
              settlementDataErrCode: _vm.settlementDataErrCode,
            },
            on: {
              reset: _vm.handleReset,
              "yoyo-used": _vm.handleYoYoUsed,
              "coupon-selected": _vm.handleCouponSelected,
            },
          }),
          _c("PaymentMethod", {
            ref: "paymentMethod",
            attrs: { bankInfo: _vm.bankData },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "h-17" }),
      _c(
        "div",
        {
          staticClass:
            "fixed z-50 h-17 bottom-0 left-0 right-0 pb-[env(safe-area-inset-bottom)] yoyo-container mx-auto",
        },
        [
          _c(
            "div",
            {
              staticClass:
                "flex items-center space-x-3 w-full h-17 lg:mx-4 lg:w-[calc(100%-2rem)] bg-white border-t border-gray-200 py-3 px-3",
            },
            [
              _c("div", { staticClass: "flex-1 text-right mr-4" }, [
                _c("div", { staticClass: "text-lg font-bold text-[#ff7a00]" }, [
                  _vm._v(
                    "RM " +
                      _vm._s(
                        _vm.formatToYuan(
                          _vm.settlementData.price &&
                            _vm.settlementData.price.payPrice
                        )
                      )
                  ),
                ]),
                _vm.isRegister != null && !_vm.isLoggedIn
                  ? _c("div", { staticClass: "text-sm text-gray-500" }, [
                      _vm.isRegister == false
                        ? _c(
                            "div",
                            { staticClass: "flex items-center justify-end" },
                            [
                              _c(
                                "van-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    size: "mini",
                                    plain: "",
                                    color: "#ff7a00",
                                  },
                                  on: { click: _vm.handleLogin },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t("products.registerMember")
                                      ) +
                                      " "
                                  ),
                                ]
                              ),
                              _c("span", { staticClass: "ml-1" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t("products.registerMemberDiscount")
                                  )
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.isRegister == true
                        ? _c(
                            "div",
                            { staticClass: "flex items-center justify-end" },
                            [
                              _c(
                                "van-button",
                                {
                                  attrs: {
                                    type: "primary",
                                    size: "mini",
                                    plain: "",
                                    color: "#ff7a00",
                                  },
                                  on: { click: _vm.handleLogin },
                                },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.$t("products.loginMember")) +
                                      " "
                                  ),
                                ]
                              ),
                              _c("span", { staticClass: "ml-1" }, [
                                _vm._v(
                                  _vm._s(_vm.$t("products.loginMemberDiscount"))
                                ),
                              ]),
                              _c("span", [
                                _vm._v(_vm._s(_vm.settlementData.givePoint)),
                              ]),
                              _c("span", [
                                _vm._v(_vm._s(_vm.$t("products.yoyoCoins"))),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                    ])
                  : _vm._e(),
              ]),
              _c(
                "van-button",
                {
                  staticClass: "rounded-xl w-24 h-8",
                  attrs: { type: "primary", color: "#ff7a00" },
                  on: { click: _vm.handleCheckout },
                },
                [_vm._v(" " + _vm._s(_vm.$t("products.checkout")) + " ")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "CommonDialog",
        {
          attrs: {
            visible: _vm.waitingForPayment,
            title: _vm.$t("pay.title"),
            buttons: [
              {
                text: _vm.$t("common.confirm"),
                type: "primary",
                action: "submit",
              },
            ],
          },
          on: {
            "update:visible": function ($event) {
              _vm.waitingForPayment = $event
            },
            "button-click": _vm.handleWaitingForPaymentClose,
            close: _vm.handleWaitingForPaymentClose,
          },
        },
        [
          _c("div", { staticClass: "text-center" }, [
            _c("div", { staticClass: "mb-4" }, [
              _vm._v(" " + _vm._s(_vm.$t("pay.waitingForPayment")) + " "),
            ]),
          ]),
        ]
      ),
      _c(
        "CommonDialog",
        {
          attrs: {
            visible: _vm.orderSuccess,
            title: _vm.$t("pay.title"),
            buttons: [
              {
                text: _vm.$t("common.confirm"),
                type: "primary",
                action: "submit",
              },
            ],
          },
          on: {
            "update:visible": function ($event) {
              _vm.orderSuccess = $event
            },
            "button-click": _vm.handleOrderSuccess,
            close: _vm.handleOrderSuccessClose,
          },
        },
        [
          _c("div", { staticClass: "text-center" }, [
            _c("div", { staticClass: "mb-4" }, [
              _vm._v(" " + _vm._s(_vm.$t("pay.orderSuccess")) + " "),
            ]),
          ]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }